import { DomSanitizer } from '@angular/platform-browser';
import { ChatPanelMessage } from '../models/chat-panel-message';
import { formatChatMessageHtml } from './chat-message-format.util';

function messageHtmlCacheKey(message: ChatPanelMessage): string {
  return `${message.id ?? ''}|${message.role}|${message.text}|${JSON.stringify(message.tokens ?? [])}`;
}

export function buildMessageHtmlCache(
  message: ChatPanelMessage,
  sanitizer: DomSanitizer,
): ChatPanelMessage {
  if (message.loading || !message.text) {
    return message;
  }

  const key = messageHtmlCacheKey(message);
  if (message.htmlCacheKey === key && message.htmlCache) {
    return message;
  }

  return {
    ...message,
    htmlCacheKey: key,
    htmlCache: sanitizer.bypassSecurityTrustHtml(
      formatChatMessageHtml(message.text, message.tokens ?? []),
    ),
  };
}

export function buildMessagesHtmlCache(
  messages: ChatPanelMessage[],
  sanitizer: DomSanitizer,
): ChatPanelMessage[] {
  return messages.map((message) => buildMessageHtmlCache(message, sanitizer));
}
